import { useMemo, useState } from "react";
import { BillExportRepositoryImpl } from "../../data/repositories/BillExportRepositoryImpl";
import { DownloadBillExportExcelUseCase } from "../../domain/use-cases/bills/DownloadBillExportExcelUseCase";

const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const useBillExcelExport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  const useCase = useMemo(() => {
    const repo = new BillExportRepositoryImpl();
    return new DownloadBillExportExcelUseCase(repo);
  }, []);

  const download = async (params?: { fromDate?: string; toDate?: string }) => {
    try {
      setError("");
      setLoading(true);
      const entity = await useCase.execute(params);
      downloadBlob(entity.blob, entity.filename);
    } catch (e: any) {
      setError(e?.message || "Failed to download bills export.");
      throw e;
    } finally {
      setLoading(false);
    }
  };

  return { download, loading, error };
};

